export const Logo = () => (
  <svg
    width="142"
    height="40"
    viewBox="0 0 142 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.1777 39.4697C14.6867 40.1882 15.7615 40.1741 16.2513 39.4425L27.2544 23.0065C33.8381 13.172 26.7578 0 14.888 0C2.83996 0 -4.20126 13.525 2.74325 23.3283L14.1777 39.4697Z"
      fill="#1F76D5"
    />
    <path
      d="M3.63928 16.2359C2.97275 9.49426 8.28652 3.65039 15.0832 3.65039C21.6489 3.65039 26.8818 9.12039 26.5695 15.657C26.4657 16.8918 26.3808 17.5682 26.0828 18.6504H4.08276C3.80852 17.8472 3.72207 17.3089 3.63928 16.2359Z"
      fill="white"
    />
    <path
      d="M14.5635 27.5678L5.33768 22.1642C5.06554 22.0048 4.72253 22.2001 4.72253 22.5145C4.72253 22.6465 4.78699 22.7704 4.8953 22.8466L14.475 29.5797C14.9121 29.887 15.4985 29.8786 15.9265 29.5589L24.9168 22.845C25.0179 22.7695 25.0774 22.651 25.0774 22.5252C25.0774 22.2111 24.7305 22.0197 24.463 22.1861L15.8428 27.5508C15.4529 27.7934 14.9598 27.8 14.5635 27.5678Z"
      fill="white"
    />
    <path
      d="M16.5828 16.1504C16.5828 16.9788 15.9112 17.6504 15.0828 17.6504C14.2543 17.6504 13.5828 16.9788 13.5828 16.1504C13.5828 15.3219 14.2543 14.6504 15.0828 14.6504C15.9112 14.6504 16.5828 15.3219 16.5828 16.1504Z"
      fill="#1F76D5"
    />
    <path
      d="M39.0161 31.3329V10.6045H45.3076C46.7571 10.6045 47.983 10.8195 48.9854 11.2494C50.0031 11.6793 50.8204 12.2474 51.4372 12.9537C52.054 13.6447 52.5012 14.4047 52.7788 15.2338C53.0718 16.0476 53.2182 16.8537 53.2182 17.6521C53.2182 18.4352 53.0795 19.2413 52.8019 20.0705C52.5243 20.8842 52.0694 21.6443 51.4372 22.3506C50.8204 23.0415 50.0108 23.602 49.0085 24.0319C48.0062 24.4618 46.7725 24.6768 45.3076 24.6768H43.0408V31.3329H39.0161ZM43.0408 21.0838H45.0763C46.0632 21.0838 46.8419 20.915 47.4125 20.5772C47.9985 20.224 48.4148 19.7864 48.6615 19.2644C48.9237 18.7423 49.0548 18.2049 49.0548 17.6521C49.0548 17.1147 48.9314 16.585 48.6847 16.063C48.4379 15.5256 48.0216 15.0803 47.4356 14.7271C46.8651 14.374 46.0786 14.1974 45.0763 14.1974H43.0408V21.0838ZM55.4778 31.3329V17.514H59.5023V31.3329H55.4778ZM57.4903 15.5102C56.8889 15.5102 56.3799 15.3029 55.9636 14.8884C55.5472 14.4738 55.339 13.9671 55.339 13.3683C55.339 12.7541 55.5472 12.2474 55.9636 11.8482C56.3799 11.4336 56.8889 11.2263 57.4903 11.2263C58.1071 11.2263 58.616 11.4336 59.0169 11.8482C59.4333 12.2474 59.6411 12.7541 59.6411 13.3683C59.6411 13.9671 59.4333 14.4738 59.0169 14.8884C58.616 15.3029 58.1071 15.5102 57.4903 15.5102ZM62.5876 31.3329V17.514H66.196V19.034C66.6895 18.3892 67.2983 17.8978 68.023 17.56C68.7478 17.2222 69.5268 17.0533 70.3595 17.0533C71.3464 17.0533 72.2636 17.2913 73.1117 17.7673C73.9753 18.2279 74.6692 18.9112 75.1935 19.8171C75.7332 20.7077 76.0033 21.7901 76.0033 23.0646V31.3329H71.9786V23.5943C71.9786 22.8266 71.7473 22.1433 71.2847 21.5445C70.8221 20.9457 70.159 20.6462 69.2955 20.6462C68.6016 20.6462 67.9767 20.8842 67.4216 21.3602C66.8819 21.8209 66.6124 22.5502 66.6124 23.5482V31.3329H62.5876ZM84.8466 38.703C83.7672 38.703 82.734 38.5418 81.7471 38.2193C80.7756 37.9122 79.9349 37.49 79.2256 36.9526L80.1971 32.9912C80.6905 33.6514 81.3382 34.1888 82.14 34.6034C82.9419 35.0333 83.8443 35.2483 84.8466 35.2483C86.2653 35.2483 87.3675 34.8414 88.154 34.0276C88.9404 33.2292 89.3339 32.2004 89.3339 30.9414V29.974C88.8096 30.5114 88.1774 30.9337 87.4372 31.2408C86.7125 31.5479 85.9106 31.7014 85.0316 31.7014C83.7518 31.7014 82.5872 31.3713 81.5386 30.711C80.49 30.0508 79.6499 29.1756 79.0177 28.0854C78.4009 26.9799 78.0925 25.7593 78.0925 24.4234C78.0925 23.0876 78.4009 21.8669 79.0177 20.7614C79.6499 19.6559 80.49 18.7807 81.5386 18.1358C82.5872 17.4756 83.7518 17.1455 85.0316 17.1455C85.926 17.1455 86.7433 17.3067 87.4835 17.6291C88.2237 17.9362 88.8559 18.3661 89.3802 18.9189V17.514H92.8498V31.5171C92.8498 33.0219 92.4797 34.3116 91.7395 35.3864C90.9993 36.4612 90.0198 37.2827 88.8016 37.8508C87.5834 38.4189 86.2653 38.703 84.8466 38.703ZM85.5171 28.1776C86.1956 28.1776 86.8124 28.0087 87.3675 27.6709C87.9227 27.3331 88.3624 26.8801 88.6863 26.312C89.0255 25.7439 89.1951 25.1144 89.1951 24.4234C89.1951 23.7325 89.0255 23.1029 88.6863 22.5348C88.3624 21.9667 87.9227 21.5138 87.3675 21.176C86.8124 20.8382 86.1956 20.6693 85.5171 20.6693C84.8386 20.6693 84.2218 20.8382 83.6666 21.176C83.1115 21.5138 82.6643 21.9667 82.3251 22.5348C82.0012 23.1029 81.8396 23.7325 81.8396 24.4234C81.8396 25.1144 82.0012 25.7439 82.3251 26.312C82.6643 26.8801 83.1115 27.3331 83.6666 27.6709C84.2218 28.0087 84.8386 28.1776 85.5171 28.1776ZM102.117 32.0238L94.5078 17.514H98.9716L101.146 21.959C101.346 22.3429 101.531 22.7268 101.701 23.1106C101.871 23.4791 102.04 23.9014 102.21 24.3774C102.38 23.9014 102.549 23.4791 102.719 23.1106C102.888 22.7268 103.073 22.3429 103.274 21.959L105.448 17.514H109.728L102.117 32.0238ZM111.424 31.3329V17.514H115.449V31.3329H111.424ZM113.437 15.5102C112.836 15.5102 112.327 15.3029 111.911 14.8884C111.494 14.4738 111.286 13.9671 111.286 13.3683C111.286 12.7541 111.494 12.2474 111.911 11.8482C112.327 11.4336 112.836 11.2263 113.437 11.2263C114.054 11.2263 114.563 11.4336 114.964 11.8482C115.38 12.2474 115.588 12.7541 115.588 13.3683C115.588 13.9671 115.38 14.4738 114.964 14.8884C114.563 15.3029 114.054 15.5102 113.437 15.5102ZM120.154 31.3329V20.6923H117.563V17.514H120.223V12.9076H124.109V17.514H126.861V20.6923H124.178V31.3329H120.154ZM135.454 31.7935C133.896 31.7935 132.524 31.4711 131.336 30.8262C130.149 30.1813 129.224 29.2984 128.561 28.1776C127.898 27.0413 127.567 25.7439 127.567 24.2852C127.567 22.888 127.89 21.652 128.538 20.5772C129.186 19.487 130.057 18.6271 131.151 17.9976C132.262 17.3681 133.488 17.0533 134.829 17.0533C136.202 17.0533 137.428 17.3681 138.507 17.9976C139.586 18.6118 140.434 19.4563 141.051 20.5311C141.684 21.6059 142 22.8266 142 24.1931V25.598H133.534C133.149 25.598 132.779 25.575 132.424 25.5289C132.069 25.4829 131.715 25.4291 131.36 25.3677C131.545 26.289 132 27.0413 132.724 27.6248C133.464 28.1929 134.405 28.477 135.546 28.477C136.425 28.477 137.212 28.3004 137.906 27.9473C138.615 27.5941 139.193 27.1565 139.641 26.6345L140.52 30.2274C139.826 30.7494 139.039 31.141 138.16 31.402C137.297 31.663 136.394 31.7935 135.454 31.7935ZM131.267 22.9494C132.038 22.7805 132.794 22.6961 133.534 22.6961H135.986C136.418 22.6961 136.826 22.7114 137.212 22.7421C137.597 22.7728 137.96 22.8266 138.299 22.9033C138.068 22.0742 137.643 21.4216 137.027 20.9457C136.425 20.4697 135.678 20.2317 134.783 20.2317C133.935 20.2317 133.195 20.4774 132.563 20.9687C131.946 21.4447 131.514 22.1049 131.267 22.9494Z"
      fill="#0B243E"
    />
    <path
      d="M8.58276 10.6504C10.3185 8.72747 12.6522 7.65039 15.0828 7.65039C17.5133 7.65039 19.847 8.72747 21.5828 10.6504"
      stroke="#1F76D5"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.5828 13.0797C12.5174 12.1635 13.774 11.6504 15.0828 11.6504C16.3915 11.6504 17.6481 12.1635 18.5828 13.0797"
      stroke="#1F76D5"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const LogoIcon = () => (
  <svg
    name="LogoIcon"
    width="48"
    height="67"
    viewBox="0 0 48 67"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M25.6557 65.405C24.8676 66.623 23.0855 66.623 22.2974 65.405L3.87959 36.9411C-6.42605 21.0142 5.00622 1.65844e-06 23.9765 0C42.9468 -1.65844e-06 54.3791 21.0142 44.0735 36.9411L25.6557 65.405Z"
      fill="#1E78D5"
    />
    <path
      d="M24.3774 7C15.5408 7 5.87716 15 8.37737 27.5H40.3774C43.5928 15.5 33.2139 7 24.3774 7Z"
      fill="white"
    />
    <path
      d="M23.3802 41.8109L7.97999 32.1307C7.54384 31.8566 6.97653 32.1701 6.97653 32.6852C6.97653 32.8842 7.06697 33.0724 7.22233 33.1966L21.9029 44.9411C23.3977 46.1369 25.53 46.1061 26.9896 44.8677L40.7494 33.1927C40.8935 33.0705 40.9765 32.8911 40.9765 32.7021C40.9765 32.1883 40.4038 31.8818 39.9763 32.1668L25.554 41.7817C24.8984 42.2188 24.0473 42.2302 23.3802 41.8109Z"
      fill="white"
    />
    <path
      d="M14.0079 17.481C13.6897 16.953 13.7367 16.2765 14.1548 15.8235C19.924 9.5704 28.1216 9.21283 34.7453 15.8328C35.1894 16.2767 35.2544 16.9679 34.9303 17.5056C34.4488 18.3044 33.3416 18.426 32.649 17.8014C26.419 12.1822 21.1939 13.4216 16.3301 17.7864C15.6235 18.4205 14.498 18.2941 14.0079 17.481Z"
      fill="#1E78D5"
    />
    <path
      d="M17.5753 21.3667C17.487 21.0426 17.5445 20.6934 17.7516 20.429C21.2122 16.011 27.5676 15.7649 31.1377 20.4432C31.3331 20.6992 31.3872 21.0344 31.3026 21.3451C31.0475 22.2816 29.7476 22.4668 29.1014 21.7427C26.1758 18.4646 22.6792 18.7229 19.8132 21.8011C19.1414 22.5227 17.8344 22.318 17.5753 21.3667Z"
      fill="#1E78D5"
    />
    <path
      d="M26.4765 24C26.4765 25.1046 25.5811 26 24.4765 26C23.372 26 22.4765 25.1046 22.4765 24C22.4765 22.8954 23.372 22 24.4765 22C25.5811 22 26.4765 22.8954 26.4765 24Z"
      fill="#1E78D5"
    />
  </svg>
);
export const ArrowUpRight = () => (
  <svg
    name="ArrowUpRight"
    width="1em"
    height="1em"
    viewBox="0 0 26 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M25.4736 2.26281V20.2802C25.4736 20.6477 25.3275 21.0003 25.0676 21.2602C24.8077 21.5201 24.4552 21.6661 24.0876 21.6661C23.72 21.6661 23.3675 21.5201 23.1076 21.2602C22.8477 21.0003 22.7017 20.6477 22.7017 20.2802V5.60811L2.893 25.4186C2.6329 25.6786 2.2802 25.8247 1.9124 25.8247C1.5446 25.8247 1.1919 25.6786 0.931896 25.4186C0.671796 25.1585 0.525696 24.8058 0.525696 24.438C0.525696 24.0702 0.671796 23.7175 0.931896 23.4574L20.7423 3.64881H6.0703C5.7027 3.64881 5.3502 3.50271 5.0903 3.24281C4.8303 2.98291 4.6843 2.63041 4.6843 2.26281C4.6843 1.89521 4.8303 1.54271 5.0903 1.28281C5.3502 1.02291 5.7027 0.876862 6.0703 0.876862H24.0876C24.4552 0.876862 24.8077 1.02291 25.0676 1.28281C25.3275 1.54271 25.4736 1.89521 25.4736 2.26281Z"
      fill="currentColor"
    />
  </svg>
);
export const EmailIcon = () => (
  <svg
    name="EmailIcon"
    width="1em"
    height="1em"
    viewBox="0 0 21 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_2373_5)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.3254 4.82126L11.2348 11.5213C11.0049 11.7118 10.7157 11.816 10.4171 11.816C10.1186 11.816 9.82937 11.7118 9.59947 11.5213L1.51271 4.82126C1.46932 4.95187 1.44725 5.08862 1.44735 5.22624V15.4788C1.44735 15.8187 1.58237 16.1447 1.82272 16.3851C2.06306 16.6254 2.38903 16.7604 2.72893 16.7604H18.1079C18.4478 16.7604 18.7737 16.6254 19.0141 16.3851C19.2544 16.1447 19.3895 15.8187 19.3895 15.4788V5.22624C19.39 5.08869 19.3683 4.95194 19.3254 4.82126ZM2.72893 2.66309H18.1079C18.7877 2.66309 19.4396 2.93313 19.9203 3.41382C20.401 3.8945 20.671 4.54645 20.671 5.22624V15.4788C20.671 16.1586 20.401 16.8106 19.9203 17.2913C19.4396 17.772 18.7877 18.042 18.1079 18.042H2.72893C2.04914 18.042 1.39719 17.772 0.916503 17.2913C0.435818 16.8106 0.165771 16.1586 0.165771 15.4788V5.22624C0.165771 4.54645 0.435818 3.8945 0.916503 3.41382C1.39719 2.93313 2.04914 2.66309 2.72893 2.66309ZM2.4598 3.94466L9.60588 9.84377C9.83475 10.0328 10.1221 10.1365 10.419 10.1372C10.7158 10.1379 11.0037 10.0355 11.2335 9.84762L18.4513 3.94466H2.4598Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_2373_5">
        <rect width="21" height="21" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export const LockIcon = () => (
  <svg
    name="LockIcon"
    width="1em"
    height="1em"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.2607 22H3.73928C2.50428 22 1.5 20.9825 1.5 19.7312V9.14372C1.5 7.89247 2.50428 6.87497 3.73928 6.87497H18.2607C19.4957 6.87497 20.5 7.89247 20.5 9.14372V19.7175C20.5 20.9687 19.4957 21.9862 18.2607 21.9862V22ZM3.73928 8.24998C3.25071 8.24998 2.85714 8.64872 2.85714 9.14372V19.7175C2.85714 20.2124 3.25071 20.6112 3.73928 20.6112H18.2607C18.7493 20.6112 19.1428 20.2124 19.1428 19.7175V9.14372C19.1428 8.64872 18.7493 8.24998 18.2607 8.24998H3.73928Z"
      fill="currentColor"
    />
    <path
      d="M17.1606 8.24999H4.83773V6.24249C4.83773 2.80499 7.60629 0 10.9992 0C14.392 0 17.1606 2.80499 17.1606 6.24249V8.24999ZM6.19486 6.87499H15.8034V6.24249C15.8034 3.56124 13.6456 1.37499 10.9992 1.37499C8.35272 1.37499 6.19486 3.56124 6.19486 6.24249V6.87499Z"
      fill="currentColor"
    />
    <path
      d="M16.4283 15.8125C17.1778 15.8125 17.7854 15.1969 17.7854 14.4375C17.7854 13.6781 17.1778 13.0625 16.4283 13.0625C15.6787 13.0625 15.0711 13.6781 15.0711 14.4375C15.0711 15.1969 15.6787 15.8125 16.4283 15.8125Z"
      fill="currentColor"
    />
    <path
      d="M10.9993 15.8125C11.7488 15.8125 12.3564 15.1969 12.3564 14.4375C12.3564 13.6781 11.7488 13.0625 10.9993 13.0625C10.2497 13.0625 9.64208 13.6781 9.64208 14.4375C9.64208 15.1969 10.2497 15.8125 10.9993 15.8125Z"
      fill="currentColor"
    />
    <path
      d="M5.57118 15.8125C6.3207 15.8125 6.92831 15.1969 6.92831 14.4375C6.92831 13.6781 6.3207 13.0625 5.57118 13.0625C4.82164 13.0625 4.21403 13.6781 4.21403 14.4375C4.21403 15.1969 4.82164 15.8125 5.57118 15.8125Z"
      fill="currentColor"
    />
  </svg>
);
export const DashboardIcon = () => (
  <svg
    name="DashboardIcon"
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19.318 13.5H15.443C14.9293 13.4995 14.4364 13.7027 14.0724 14.065C13.7083 14.4274 13.5029 14.9193 13.501 15.433V19.308C13.5007 19.5631 13.5508 19.8158 13.6483 20.0515C13.7458 20.2872 13.8888 20.5014 14.0692 20.6818C14.2496 20.8622 14.4638 21.0052 14.6995 21.1027C14.9353 21.2002 15.1879 21.2503 15.443 21.25H19.318C19.8315 21.2479 20.3232 21.0423 20.6853 20.6783C21.0475 20.3142 21.2505 19.8215 21.25 19.308V15.433C21.2503 15.1792 21.2005 14.9279 21.1035 14.6933C21.0065 14.4588 20.8642 14.2457 20.6847 14.0663C20.5053 13.8868 20.2922 13.7445 20.0577 13.6475C19.8231 13.5505 19.5718 13.5007 19.318 13.501M8.557 13.5H4.682C4.16859 13.5029 3.67721 13.7089 3.3152 14.073C2.95319 14.437 2.74999 14.9296 2.75 15.443V19.318C2.74974 19.5718 2.79953 19.8231 2.89653 20.0577C2.99353 20.2922 3.13583 20.5053 3.31528 20.6847C3.49474 20.8642 3.70783 21.0065 3.94235 21.1035C4.17687 21.2005 4.42821 21.2503 4.682 21.25H8.557C9.07048 21.2505 9.56324 21.0475 9.92726 20.6853C10.2913 20.3232 10.4969 19.8315 10.499 19.318V15.443C10.4993 15.1879 10.4492 14.9353 10.3517 14.6995C10.2542 14.4638 10.1112 14.2496 9.93079 14.0692C9.75041 13.8888 9.53622 13.7458 9.30048 13.6483C9.06475 13.5508 8.8121 13.5007 8.557 13.501M8.557 2.75H4.682C4.42821 2.74974 4.17687 2.79953 3.94235 2.89653C3.70783 2.99353 3.49474 3.13583 3.31528 3.31528C3.13583 3.49474 2.99353 3.70783 2.89653 3.94235C2.79953 4.17687 2.74974 4.42821 2.75 4.682V8.557C2.74947 9.07048 2.95253 9.56324 3.31468 9.92726C3.67683 10.2913 4.16852 10.4969 4.682 10.499H8.557C8.8121 10.4993 9.06475 10.4492 9.30048 10.3517C9.53622 10.2542 9.75041 10.1112 9.93079 9.93079C10.1112 9.75041 10.2542 9.53622 10.3517 9.30048C10.4492 9.06475 10.4993 8.8121 10.499 8.557V4.682C10.4969 4.16852 10.2913 3.67683 9.92726 3.31468C9.56324 2.95253 9.07048 2.74947 8.557 2.75ZM19.318 2.75H15.443C14.9295 2.74947 14.4368 2.95253 14.0727 3.31468C13.7087 3.67683 13.5031 4.16852 13.501 4.682V8.557C13.5013 9.07197 13.706 9.56577 14.0701 9.92991C14.4342 10.294 14.928 10.4987 15.443 10.499H19.318C19.8315 10.4969 20.3232 10.2913 20.6853 9.92726C21.0475 9.56324 21.2505 9.07048 21.25 8.557V4.682C21.2503 4.42821 21.2005 4.17687 21.1035 3.94235C21.0065 3.70783 20.8642 3.49474 20.6847 3.31528C20.5053 3.13583 20.2922 2.99353 20.0577 2.89653C19.8231 2.79953 19.5718 2.74974 19.318 2.75Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const MyEventIcon = () => (
  <svg
    name="MyEventIcon"
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21 4.5C21 4.10218 20.842 3.72064 20.5607 3.43934C20.2794 3.15804 19.8978 3 19.5 3H16.5V1.5H15V3H9V1.5H7.5V3H4.5C4.10218 3 3.72064 3.15804 3.43934 3.43934C3.15804 3.72064 3 4.10218 3 4.5V19.5C3 19.8978 3.15804 20.2794 3.43934 20.5607C3.72064 20.842 4.10218 21 4.5 21H7.5V19.5H4.5V4.5H7.5V6H9V4.5H15V6H16.5V4.5H19.5V9H21V4.5Z"
      fill="currentColor"
    />
    <path
      d="M15.75 11.25L17.6617 14.9535L21.75 15.5468L18.75 18.4297L19.5 22.5L15.75 20.5785L12 22.5L12.75 18.4297L9.75 15.5468L13.95 14.9535L15.75 11.25Z"
      fill="currentColor"
    />
  </svg>
);
export const LocationIcon = () => (
  <svg
    name="LocationIcon"
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7 18C5.171 18.412 4 19.044 4 19.754C4 20.994 7.582 22 12 22C16.418 22 20 20.994 20 19.754C20 19.044 18.829 18.412 17 18M14.5 9C14.5 9.66304 14.2366 10.2989 13.7678 10.7678C13.2989 11.2366 12.663 11.5 12 11.5C11.337 11.5 10.7011 11.2366 10.2322 10.7678C9.76339 10.2989 9.5 9.66304 9.5 9C9.5 8.33696 9.76339 7.70107 10.2322 7.23223C10.7011 6.76339 11.337 6.5 12 6.5C12.663 6.5 13.2989 6.76339 13.7678 7.23223C14.2366 7.70107 14.5 8.33696 14.5 9Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.2575 17.494C12.9197 17.819 12.4692 18.0005 12.0005 18.0005C11.5318 18.0005 11.0813 17.819 10.7435 17.494C7.65448 14.501 3.51548 11.158 5.53348 6.304C6.62648 3.679 9.24648 2 12.0005 2C14.7545 2 17.3755 3.68 18.4675 6.304C20.4835 11.151 16.3545 14.511 13.2575 17.494Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const ContactIcon = () => (
  <svg
    name="ContactIcon"
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 4V2M16 4V2M12 22C7.993 22 5.99 22 4.745 20.682C3.5 19.364 3.5 17.242 3.5 13C3.5 8.758 3.5 6.636 4.745 5.318C5.99 4 7.993 4 12 4C16.007 4 18.01 4 19.255 5.318C20.5 6.636 20.5 8.758 20.5 13C20.5 17.242 20.5 19.364 19.255 20.682C18.01 22 16.007 22 12 22Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.0178 9.49301C14.0178 10.0234 13.8071 10.5322 13.432 10.9072C13.057 11.2823 12.5483 11.493 12.0178 11.493C11.4874 11.493 10.9787 11.2823 10.6036 10.9072C10.2285 10.5322 10.0178 10.0234 10.0178 9.49301C10.0178 8.96258 10.2285 8.45387 10.6036 8.0788C10.9787 7.70373 11.4874 7.49301 12.0178 7.49301C12.5483 7.49301 13.057 7.70373 13.432 8.0788C13.8071 8.45387 14.0178 8.96258 14.0178 9.49301ZM8.06283 16.716C9.12083 15.086 10.8018 14.476 12.0178 14.477C13.2338 14.478 14.8658 15.087 15.9238 16.717C15.9918 16.822 16.0108 16.951 15.9488 17.061C15.7018 17.5 14.9328 18.371 14.3788 18.43C13.7408 18.497 12.0718 18.507 12.0188 18.507C11.9658 18.507 10.2468 18.497 9.60883 18.43C9.05283 18.37 8.28483 17.5 8.03683 17.06C7.97583 16.951 7.99483 16.822 8.06283 16.716Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const SettingsIcon = () => (
  <svg
    name="SettingsIcon"
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <path
      d="M13.7655 2.152C13.3985 2 12.9325 2 12.0005 2C11.0685 2 10.6025 2 10.2355 2.152C9.99263 2.25251 9.772 2.3999 9.58617 2.58572C9.40035 2.77155 9.25296 2.99218 9.15245 3.235C9.06045 3.458 9.02345 3.719 9.00945 4.098C9.00294 4.37193 8.92705 4.63973 8.78889 4.87635C8.65073 5.11298 8.45481 5.31069 8.21945 5.451C7.98026 5.58477 7.71104 5.65567 7.43698 5.65707C7.16293 5.65847 6.893 5.59032 6.65245 5.459C6.31645 5.281 6.07345 5.183 5.83245 5.151C5.30677 5.08187 4.77515 5.22431 4.35445 5.547C4.04045 5.79 3.80645 6.193 3.34045 7C2.87445 7.807 2.64045 8.21 2.58945 8.605C2.55509 8.86545 2.57237 9.13012 2.64032 9.38389C2.70826 9.63767 2.82554 9.87556 2.98545 10.084C3.13345 10.276 3.34045 10.437 3.66145 10.639C4.13445 10.936 4.43845 11.442 4.43845 12C4.43845 12.558 4.13445 13.064 3.66145 13.36C3.34045 13.563 3.13245 13.724 2.98545 13.916C2.82554 14.1244 2.70826 14.3623 2.64032 14.6161C2.57237 14.8699 2.55509 15.1345 2.58945 15.395C2.64145 15.789 2.87445 16.193 3.33945 17C3.80645 17.807 4.03945 18.21 4.35445 18.453C4.56289 18.6129 4.80078 18.7302 5.05456 18.7981C5.30833 18.8661 5.573 18.8834 5.83345 18.849C6.07345 18.817 6.31645 18.719 6.65245 18.541C6.893 18.4097 7.16293 18.3415 7.43698 18.3429C7.71104 18.3443 7.98026 18.4152 8.21945 18.549C8.70245 18.829 8.98945 19.344 9.00945 19.902C9.02345 20.282 9.05945 20.542 9.15245 20.765C9.25296 21.0078 9.40035 21.2284 9.58617 21.4143C9.772 21.6001 9.99263 21.7475 10.2355 21.848C10.6025 22 11.0685 22 12.0005 22C12.9325 22 13.3985 22 13.7655 21.848C14.0083 21.7475 14.2289 21.6001 14.4147 21.4143C14.6006 21.2284 14.7479 21.0078 14.8484 20.765C14.9404 20.542 14.9775 20.282 14.9915 19.902C15.0115 19.344 15.2985 18.828 15.7815 18.549C16.0206 18.4152 16.2899 18.3443 16.5639 18.3429C16.838 18.3415 17.1079 18.4097 17.3484 18.541C17.6844 18.719 17.9274 18.817 18.1674 18.849C18.4279 18.8834 18.6926 18.8661 18.9463 18.7981C19.2001 18.7302 19.438 18.6129 19.6465 18.453C19.9615 18.211 20.1944 17.807 20.6604 17C21.1264 16.193 21.3604 15.79 21.4114 15.395C21.4458 15.1345 21.4285 14.8699 21.3606 14.6161C21.2926 14.3623 21.1754 14.1244 21.0154 13.916C20.8674 13.724 20.6605 13.563 20.3395 13.361C20.1054 13.2184 19.9113 13.0187 19.7754 12.7807C19.6395 12.5427 19.5663 12.2741 19.5625 12C19.5625 11.442 19.8665 10.936 20.3395 10.64C20.6605 10.437 20.8684 10.276 21.0154 10.084C21.1754 9.87556 21.2926 9.63767 21.3606 9.38389C21.4285 9.13012 21.4458 8.86545 21.4114 8.605C21.3594 8.211 21.1264 7.807 20.6614 7C20.1944 6.193 19.9615 5.79 19.6465 5.547C19.438 5.38709 19.2001 5.26981 18.9463 5.20187C18.6926 5.13392 18.4279 5.11664 18.1674 5.151C17.9274 5.183 17.6845 5.281 17.3475 5.459C17.107 5.59014 16.8373 5.6582 16.5634 5.6568C16.2896 5.6554 16.0205 5.58459 15.7815 5.451C15.5461 5.31069 15.3502 5.11298 15.212 4.87635C15.0738 4.63973 14.998 4.37193 14.9915 4.098C14.9775 3.718 14.9414 3.458 14.8484 3.235C14.7479 2.99218 14.6006 2.77155 14.4147 2.58572C14.2289 2.3999 14.0083 2.25251 13.7655 2.152Z"
      stroke="currentColor"
      strokeWidth="1.5"
    />
  </svg>
);
export const BellIcon = () => (
  <svg
    name="BellIcon"
    width="1em"
    height="1em"
    viewBox="0 0 35 35"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M28.2491 13.85V12.675C28.2491 6.22667 23.2091 1 16.9991 1C10.7891 1 5.74913 6.22667 5.74913 12.675V13.85C5.75113 15.2526 5.35087 16.6263 4.59579 17.8083L2.74913 20.6833C1.06413 23.3083 2.35079 26.8767 5.28246 27.7067C12.9429 29.8761 21.0553 29.8761 28.7158 27.7067C31.6475 26.8767 32.9341 23.3083 31.2491 20.685L29.4025 17.81C28.6468 16.6282 28.246 15.2544 28.2475 13.8517L28.2491 13.85Z"
      stroke="currentColor"
      strokeWidth="2"
    />
    <path
      opacity="0.5"
      d="M9.50002 29C10.5917 31.9133 13.5367 34 17 34C20.4634 34 23.4084 31.9133 24.5 29"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);
export const DeleteIcon = () => (
  <svg
    name="DeleteIcon"
    width="1em"
    height="1em"
    viewBox="0 0 19 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_2390_2)">
      <path
        d="M0.78125 3.90282H17.9526M7.61077 13.8544V8.00053M11.1231 13.8544V8.00053M11.1231 0.780762H7.61077C7.30026 0.780762 7.00247 0.904111 6.78291 1.12367C6.56334 1.34323 6.43999 1.64102 6.43999 1.95153V3.90282H12.2939V1.95153C12.2939 1.64102 12.1705 1.34323 11.951 1.12367C11.7314 0.904111 11.4336 0.780762 11.1231 0.780762ZM14.7213 16.875C14.6996 17.1683 14.5675 17.4425 14.3517 17.6423C14.1359 17.8422 13.8524 17.9529 13.5583 17.9521H5.17556C4.88143 17.9529 4.59793 17.8422 4.38214 17.6423C4.16635 17.4425 4.0343 17.1683 4.01259 16.875L2.92767 3.90282H15.8062L14.7213 16.875Z"
        stroke="#F70808"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_2390_2">
        <rect width="19" height="19" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export const CalendarIcon = () => (
  <svg
    name="CalendarIcon"
    width="1em"
    height="1em"
    viewBox="0 0 21 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_2390_8)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.8846 4.89535C14.4851 4.89535 14.1539 4.56325 14.1539 4.16279V2.96725C13.3997 2.94186 12.514 2.94186 11.4744 2.94186H9.52565C8.48504 2.94186 7.6003 2.94186 6.84615 2.96725V4.16279C6.84615 4.56325 6.51486 4.89535 6.11538 4.89535C5.71589 4.89535 5.38461 4.56325 5.38461 4.16279V3.07274C4.46384 3.19288 3.83148 3.42437 3.38718 3.86976C2.80061 4.45776 2.58625 5.37395 2.50732 6.84883H18.4927C18.4137 5.37395 18.1984 4.45776 17.6128 3.86976C17.1685 3.42437 16.5362 3.19288 15.6154 3.07274V4.16279C15.6154 4.56325 15.2841 4.89535 14.8846 4.89535ZM18.5326 8.31396C18.5378 8.83036 18.5397 9.4001 18.5385 10.0233V11C18.5385 11.4005 18.8697 11.7326 19.2692 11.7326C19.6687 11.7326 20 11.4005 20 11V10.0233C20 6.13581 20 4.19209 18.6456 2.83442C17.8934 2.08037 16.96 1.74535 15.6154 1.59591V0.744185C15.6154 0.34372 15.2841 0.0116272 14.8846 0.0116272C14.4851 0.0116272 14.1539 0.34372 14.1539 0.744185V1.50116C13.3783 1.47674 12.4926 1.47674 11.4744 1.47674H9.52565C8.50647 1.47674 7.62174 1.47674 6.84615 1.50116V0.744185C6.84615 0.34372 6.51486 0.0116272 6.11538 0.0116272C5.71589 0.0116272 5.38461 0.34372 5.38461 0.744185V1.59591C4.03999 1.74535 3.10655 2.08037 2.35435 2.83442C0.99999 4.19209 1 6.14558 1 10.0233V11.9767C1 15.8642 0.99999 17.8079 2.35435 19.1656C3.70871 20.5233 5.64768 20.5233 9.52565 20.5233C9.92514 20.5233 10.2564 20.1912 10.2564 19.7907C10.2564 19.3902 9.92514 19.0581 9.52565 19.0581C6.05692 19.0581 4.31282 19.0581 3.38718 18.1302C2.46154 17.2023 2.46154 15.454 2.46154 11.9767V10.0233C2.46088 9.40078 2.46251 8.83095 2.46641 8.31396H18.5326ZM15.3718 21.0116C12.819 21.0116 10.7436 18.9312 10.7436 16.3721C10.7436 13.813 12.819 11.7326 15.3718 11.7326C17.9246 11.7326 20 13.813 20 16.3721C20 18.9312 17.9246 21.0116 15.3718 21.0116ZM15.3718 13.1977C13.6277 13.1977 12.2051 14.6237 12.2051 16.3721C12.2051 18.1205 13.6277 19.5465 15.3718 19.5465C17.1159 19.5465 18.5385 18.1205 18.5385 16.3721C18.5385 14.6237 17.1159 13.1977 15.3718 13.1977ZM15.8297 17.8665C15.9759 18.013 16.161 18.0814 16.3462 18.0814C16.5313 18.0814 16.7164 18.013 16.8626 17.8665C17.1451 17.5833 17.1451 17.1144 16.8626 16.8312L16.1026 16.0693V14.4186C16.1026 14.0181 15.7713 13.686 15.3718 13.686C14.9723 13.686 14.641 14.0181 14.641 14.4186V16.3721C14.641 16.5674 14.719 16.753 14.8554 16.8898L15.8297 17.8665Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_2390_8">
        <rect width="21" height="21" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export const LocationPinIcon = () => (
  <svg
    name="LocationPinIcon"
    width="1em"
    height="1em"
    viewBox="0 0 46 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M37.1556 36.0136C37.7148 35.7339 38.3571 35.669 38.9608 35.8314C39.5646 35.9937 40.0878 36.372 40.4312 36.8944L40.5793 37.1548L45.6854 47.3671C45.8676 47.7313 45.96 48.1338 45.955 48.5409C45.95 48.9481 45.8476 49.3482 45.6564 49.7078C45.4653 50.0673 45.1909 50.3759 44.8562 50.6079C44.5215 50.8398 44.1361 50.9883 43.7323 51.041L43.403 51.0614H2.55389C2.1466 51.0615 1.74519 50.9642 1.38317 50.7776C1.02116 50.5909 0.709051 50.3204 0.472909 49.9885C0.236767 49.6567 0.0834458 49.2732 0.025748 48.87C-0.0319498 48.4668 0.00765033 48.0557 0.141242 47.6709L0.268895 47.3645L5.37503 37.1523C5.66123 36.5607 6.1645 36.1023 6.78013 35.8724C7.39576 35.6425 8.07632 35.6588 8.68021 35.918C9.28409 36.1772 9.76478 36.6593 10.0222 37.2639C10.2797 37.8685 10.2941 38.5491 10.0625 39.1641L9.94247 39.4373L6.68476 45.9552H39.2721L36.0144 39.4373C35.7121 38.8319 35.6624 38.1312 35.8764 37.4892C36.0904 36.8473 36.5505 36.3165 37.1556 36.0136ZM22.9784 0C27.7183 0 32.2639 1.88288 35.6155 5.23444C38.967 8.58599 40.8499 13.1317 40.8499 17.8715C40.8499 23.9529 37.559 28.8931 34.1532 32.3984C32.2721 34.3095 30.204 36.0269 27.9799 37.525L27.0276 38.1531L26.18 38.6866L25.7996 38.9164L25.1434 39.2943C23.7954 40.0602 22.1615 40.0602 20.8134 39.2943L20.1573 38.9139L19.3658 38.4313L18.9293 38.1531L17.977 37.525C15.7529 36.0269 13.6848 34.3095 11.8037 32.3984C8.39787 28.8931 5.10696 23.9529 5.10696 17.8715C5.10696 13.1317 6.98984 8.58599 10.3414 5.23444C13.6929 1.88288 18.2386 0 22.9784 0ZM22.9784 5.10614C19.5929 5.10614 16.3459 6.45105 13.952 8.84502C11.558 11.239 10.2131 14.4859 10.2131 17.8715C10.2131 22.0483 12.4853 25.7732 15.4648 28.8395C17.2569 30.6496 19.2374 32.2629 21.3726 33.652L22.2406 34.206C22.5095 34.3711 22.7555 34.5192 22.9784 34.6502L23.7188 34.206L24.5843 33.652C26.7194 32.2629 28.7 30.6496 30.4921 28.8395C33.4716 25.7758 35.7438 22.0483 35.7438 17.8715C35.7438 14.4859 34.3989 11.239 32.0049 8.84502C29.6109 6.45105 26.364 5.10614 22.9784 5.10614ZM22.9784 10.2123C25.0098 10.2123 26.9579 11.0192 28.3943 12.4556C29.8307 13.892 30.6376 15.8401 30.6376 17.8715C30.6376 19.9028 29.8307 21.851 28.3943 23.2874C26.9579 24.7237 25.0098 25.5307 22.9784 25.5307C20.9471 25.5307 18.9989 24.7237 17.5626 23.2874C16.1262 21.851 15.3192 19.9028 15.3192 17.8715C15.3192 15.8401 16.1262 13.892 17.5626 12.4556C18.9989 11.0192 20.9471 10.2123 22.9784 10.2123ZM22.9784 15.3184C22.3013 15.3184 21.6519 15.5874 21.1731 16.0662C20.6944 16.545 20.4254 17.1944 20.4254 17.8715C20.4254 18.5486 20.6944 19.198 21.1731 19.6768C21.6519 20.1556 22.3013 20.4245 22.9784 20.4245C23.6556 20.4245 24.3049 20.1556 24.7837 19.6768C25.2625 19.198 25.5315 18.5486 25.5315 17.8715C25.5315 17.1944 25.2625 16.545 24.7837 16.0662C24.3049 15.5874 23.6556 15.3184 22.9784 15.3184Z"
      fill="currentColor"
    />
  </svg>
);
export const SearchIcon = () => (
  <svg
    name="SearchIcon"
    width="1em"
    height="1em"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21.5002 21.5002L16.4334 16.4334M16.4334 16.4334C17.3001 15.5667 17.9876 14.5378 18.4567 13.4054C18.9257 12.273 19.1671 11.0593 19.1671 9.83357C19.1671 8.60787 18.9257 7.39417 18.4567 6.26177C17.9876 5.12937 17.3001 4.10044 16.4334 3.23374C15.5667 2.36704 14.5378 1.67953 13.4054 1.21048C12.273 0.74142 11.0593 0.5 9.83357 0.5C8.60787 0.5 7.39417 0.74142 6.26177 1.21048C5.12937 1.67953 4.10044 2.36704 3.23374 3.23374C1.48336 4.98413 0.5 7.35816 0.5 9.83357C0.5 12.309 1.48336 14.683 3.23374 16.4334C4.98412 18.1838 7.35816 19.1671 9.83357 19.1671C12.309 19.1671 14.683 18.1838 16.4334 16.4334Z"
      stroke="currentColor"
      strokeOpacity="0.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const LocationPin2Icon = () => (
  <svg
    name="LocationPin2Icon"
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.9999 13.4299C13.723 13.4299 15.1199 12.0331 15.1199 10.3099C15.1199 8.58681 13.723 7.18994 11.9999 7.18994C10.2768 7.18994 8.87988 8.58681 8.87988 10.3099C8.87988 12.0331 10.2768 13.4299 11.9999 13.4299Z"
      stroke="currentColor"
    />
    <path
      d="M3.6202 8.49C5.5902 -0.169998 18.4202 -0.159997 20.3802 8.5C21.5302 13.58 18.3702 17.88 15.6002 20.54C13.5902 22.48 10.4102 22.48 8.3902 20.54C5.6302 17.88 2.4702 13.57 3.6202 8.49Z"
      stroke="currentColor"
    />
  </svg>
);
export const CalendarListIcon = () => (
  <svg
    name="CalendarListIcon"
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 2V5"
      stroke="currentColor"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16 2V5"
      stroke="currentColor"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21 8.5V17C21 20 19.5 22 16 22H8C4.5 22 3 20 3 17V8.5C3 5.5 4.5 3.5 8 3.5H16C19.5 3.5 21 5.5 21 8.5Z"
      stroke="currentColor"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 11H16"
      stroke="currentColor"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 16H12"
      stroke="currentColor"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const WalletMoneyIcon = () => (
  <svg
    name="WalletMoneyIcon"
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.7516 16.8604V18.8904C10.7516 20.6104 9.15158 22.0004 7.18158 22.0004C5.21158 22.0004 3.60156 20.6104 3.60156 18.8904V16.8604C3.60156 18.5804 5.20158 19.8004 7.18158 19.8004C9.15158 19.8004 10.7516 18.5704 10.7516 16.8604Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.7498 14.11C10.7498 14.61 10.6098 15.07 10.3698 15.47C9.77981 16.44 8.5698 17.05 7.1698 17.05C5.7698 17.05 4.55979 16.43 3.96979 15.47C3.72979 15.07 3.58984 14.61 3.58984 14.11C3.58984 13.25 3.98982 12.48 4.62982 11.92C5.27982 11.35 6.16979 11.01 7.15979 11.01C8.14979 11.01 9.03982 11.36 9.68982 11.92C10.3498 12.47 10.7498 13.25 10.7498 14.11Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.7516 14.11V16.86C10.7516 18.58 9.15158 19.8 7.18158 19.8C5.21158 19.8 3.60156 18.57 3.60156 16.86V14.11C3.60156 12.39 5.20158 11 7.18158 11C8.17158 11 9.06161 11.35 9.71161 11.91C10.3516 12.47 10.7516 13.25 10.7516 14.11Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M22.0002 10.9699V13.03C22.0002 13.58 21.5602 14.0299 21.0002 14.0499H19.0402C17.9602 14.0499 16.9702 13.2599 16.8802 12.1799C16.8202 11.5499 17.0602 10.9599 17.4802 10.5499C17.8502 10.1699 18.3602 9.94995 18.9202 9.94995H21.0002C21.5602 9.96995 22.0002 10.4199 22.0002 10.9699Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2 10.5V8.5C2 5.78 3.64 3.88 6.19 3.56C6.45 3.52 6.72 3.5 7 3.5H16C16.26 3.5 16.51 3.50999 16.75 3.54999C19.33 3.84999 21 5.76 21 8.5V9.95001H18.92C18.36 9.95001 17.85 10.17 17.48 10.55C17.06 10.96 16.82 11.55 16.88 12.18C16.97 13.26 17.96 14.05 19.04 14.05H21V15.5C21 18.5 19 20.5 16 20.5H13.5"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const LogoutIcon = () => (
  <svg
    name="LogoutIcon"
    width="1em"
    height="1em"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="m16 17 5-5-5-5" />
    <path d="M21 12H9" />
    <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
  </svg>
);
export const UserIcon = () => (
  <svg
    name="UserIcon"
    width="1em"
    height="1em"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.99984 7.81852C9.84079 7.81852 11.3332 6.32614 11.3332 4.48519C11.3332 2.64424 9.84079 1.15186 7.99984 1.15186C6.15889 1.15186 4.6665 2.64424 4.6665 4.48519C4.6665 6.32614 6.15889 7.81852 7.99984 7.81852Z"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M13.7268 14.485C13.7268 11.905 11.1601 9.81836 8.0001 9.81836C4.8401 9.81836 2.27344 11.905 2.27344 14.485"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
export const SyncUsersIcon = () => (
  <svg
    name="SyncUsersIcon"
    width="1em"
    height="1em"
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M34.667 23C34.667 29.1275 29.45 34.0833 23 34.0833L24.75 31.3125M1.33301 12.8743C1.33301 6.74682 6.55 1.79102 13 1.79102L11.25 4.56182M22.287 10.2363C24.173 10.2363 25.69 11.6864 25.69 13.469C25.69 15.2146 24.232 16.637 22.414 16.7016C22.336 16.6924 22.248 16.6924 22.161 16.7016M24.1641 25.0143C24.8641 24.8758 25.5251 24.6079 26.0691 24.2108C27.5861 23.1302 27.5861 21.3476 26.0691 20.267C25.5341 19.879 24.8831 19.6204 24.1931 19.4727M15.239 16.5821C15.141 16.5729 15.025 16.5729 14.918 16.5821C12.604 16.5082 10.766 14.7072 10.766 12.4905C10.766 10.2276 12.691 8.38965 15.083 8.38965C17.465 8.38965 19.4 10.2276 19.4 12.4905C19.39 14.7072 17.552 16.5082 15.239 16.5821ZM10.377 19.9893C8.02504 21.4856 8.02504 23.9239 10.377 25.4109C13.051 27.1104 17.436 27.1104 20.109 25.4109C22.462 23.9147 22.462 21.4763 20.109 19.9893C17.445 18.2991 13.061 18.2991 10.377 19.9893Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
export const WalletIcon = () => (
  <svg
    name="WalletIcon"
    width="1em"
    height="1em"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_2428_23)">
      <path
        d="M11.6609 1.51814L11.6309 1.58814L8.73094 8.31814M11.6609 1.51814C8.68094 0.378136 7.20094 1.06814 5.89094 4.09814C5.86094 4.14814 5.84094 4.20814 5.82094 4.26814L5.75094 4.42814L5.71094 4.52814M11.6609 1.51814C11.8109 1.56814 11.9505 1.63855 12.1005 1.69855L14.3105 2.62855C15.5405 3.13855 16.4005 3.66855 16.9205 4.30855C17.0205 4.42855 17.1005 4.53855 17.1705 4.66855C17.2605 4.80855 17.3305 4.94856 17.3705 5.09856C17.4105 5.18856 17.4405 5.27855 17.4605 5.35855C17.7305 6.19855 17.5705 7.22855 17.0505 8.51855C16.6005 8.37855 16.1205 8.31855 15.6405 8.31855L8.73094 8.31814M8.73094 8.31814H5.88094C5.20094 8.31814 4.55094 8.45814 3.96094 8.70814M3.96094 8.70814L5.71094 4.52814M3.96094 8.70814C2.22094 9.45812 1 11.1883 1 13.1983V10.2683C1 7.42832 3.02094 5.05814 5.71094 4.52814M20.5217 13.1984V15.1484C20.5217 15.3484 20.5117 15.5484 20.5017 15.7484C20.3117 19.2384 18.3617 20.9984 14.6617 20.9984H6.86172C6.62172 20.9984 6.38172 20.9784 6.15172 20.9484C2.97172 20.7384 1.27172 19.0384 1.06172 15.8584C1.03172 15.6284 1.01172 15.3884 1.01172 15.1484V13.1984C1.01172 11.1884 2.23172 9.4584 3.97172 8.70836C4.57172 8.45836 5.21172 8.31836 5.89172 8.31836H15.6517C16.1417 8.31836 16.6217 8.38836 17.0617 8.51836C19.0517 9.1284 20.5217 10.9884 20.5217 13.1984Z"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M20.5186 10.2677V13.1977C20.5186 10.9977 19.0586 9.1277 17.0586 8.52766C17.5786 7.22766 17.7286 6.20766 17.4786 5.35766C17.4586 5.26766 17.4286 5.17766 17.3886 5.09766C19.2486 6.05766 20.5186 8.02766 20.5186 10.2677Z"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_2428_23">
        <rect width="22" height="22" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export const ContactsIcon = () => (
  <svg
    name="ContactsIcon"
    width="1em"
    height="1em"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13 7H18M14 11H18M16 15H18M11 15.3298C10.86 13.8798 9.71 12.7398 8.26 12.6098C7.76 12.5598 7.25 12.5598 6.74 12.6098C5.29 12.7498 4.14 13.8798 4 15.3298M16 20H6C2 20 1 19 1 15V7C1 3 2 2 6 2H16C20 2 21 3 21 7V15C21 19 20 20 16 20ZM7.49945 10.2899C8.49909 10.2899 9.3095 9.4796 9.3095 8.47992C9.3095 7.48029 8.49909 6.66992 7.49945 6.66992C6.49982 6.66992 5.68945 7.48029 5.68945 8.47992C5.68945 9.4796 6.49982 10.2899 7.49945 10.2899Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
export const PaymentIcon = () => (
  <svg
    name="PaymentIcon"
    width="1em"
    height="1em"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9 15H5M13 15H11.5M1 9H21M1 11C1 7.229 1 5.343 2.172 4.172C3.344 3.001 5.229 3 9 3H13C16.771 3 18.657 3 19.828 4.172C20.999 5.344 21 7.229 21 11C21 14.771 21 16.657 19.828 17.828C18.656 18.999 16.771 19 13 19H9C5.229 19 3.343 19 2.172 17.828C1.001 16.656 1 14.771 1 11Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
    />
  </svg>
);
export const ProfileIcon = () => (
  <svg
    name="ProfileIcon"
    width="1em"
    height="1em"
    viewBox="0 0 21 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_2430_42)">
      <path
        d="M1.41016 21C1.41016 17.13 5.26015 14 10.0002 14C10.9602 14 11.8902 14.13 12.7602 14.37M14.4395 17L15.4294 17.99L17.5594 16.02M10 11C12.7614 11 15 8.76142 15 6C15 3.23858 12.7614 1 10 1C7.23858 1 5 3.23858 5 6C5 8.76142 7.23858 11 10 11ZM20 17C20 17.75 19.79 18.46 19.42 19.06C19.21 19.42 18.94 19.74 18.63 20C17.93 20.63 17.01 21 16 21C14.54 21 13.27 20.22 12.58 19.06C12.21 18.46 12 17.75 12 17C12 15.74 12.58 14.61 13.5 13.88C14.19 13.33 15.06 13 16 13C18.21 13 20 14.79 20 17Z"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_2430_42">
        <rect width="21" height="22" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export const TemplateIcon = () => (
  <svg
    name="TemplateIcon"
    width="1em"
    height="1em"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_2430_48)">
      <path
        d="M7 1H2C1.44772 1 1 1.44772 1 2V18C1 18.5523 1.44772 19 2 19H7C7.55228 19 8 18.5523 8 18V2C8 1.44772 7.55228 1 7 1Z"
        stroke="currentColor"
        stroke-width="1.25"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M18 1H13C12.4477 1 12 1.44772 12 2V7C12 7.55228 12.4477 8 13 8H18C18.5523 8 19 7.55228 19 7V2C19 1.44772 18.5523 1 18 1Z"
        stroke="currentColor"
        stroke-width="1.25"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M18 12H13C12.4477 12 12 12.4477 12 13V18C12 18.5523 12.4477 19 13 19H18C18.5523 19 19 18.5523 19 18V13C19 12.4477 18.5523 12 18 12Z"
        stroke="currentColor"
        stroke-width="1.25"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_2430_48">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export const TrashIcon = () => (
  <svg
    name="TrashIcon"
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M22 5.37796C18.3 5.01496 14.5778 4.82796 10.8667 4.82796C8.66667 4.82796 6.46667 4.93796 4.26667 5.15796L2 5.37796M8.11111 4.26698L8.35556 2.82599C8.53333 1.781 8.66667 1 10.5444 1H13.4556C15.3333 1 15.4778 1.825 15.6444 2.83699L15.8889 4.26698M19.6116 8.85411L18.8893 19.931C18.7671 21.658 18.6671 23 15.5671 23H8.43377C5.33377 23 5.23377 21.658 5.11154 19.931L4.38932 8.85411M10.1446 16.9499H13.8446M9.22222 12.5499H14.7778"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
export const EditIcon = () => (
  <svg
    name="EditIcon"
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11 1.99952H9C4 1.99952 2 3.99952 2 8.99952V14.9995C2 19.9995 4 21.9995 9 21.9995H15C20 21.9995 22 19.9995 22 14.9995V12.9995M14.9102 4.14942C15.5802 6.53942 17.4502 8.40942 19.8502 9.08942M16.0399 3.01928L8.15988 10.8993C7.85988 11.1993 7.55988 11.7893 7.49988 12.2193L7.06988 15.2293C6.90988 16.3193 7.67988 17.0793 8.76988 16.9293L11.7799 16.4993C12.1999 16.4393 12.7899 16.1393 13.0999 15.8393L20.9799 7.95928C22.3399 6.59928 22.9799 5.01928 20.9799 3.01928C18.9799 1.01928 17.3999 1.65928 16.0399 3.01928Z"
      stroke="currentColor"
      stroke-width="2"
      strokeMiterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
export const ViewDetailsIcon = () => (
  <svg
    name="ViewDetailsIcon"
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.2598 7H10.0598M15 12H8.32M13.2598 17H10.0598M2 9V15C2 20 4 22 9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9Z"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
export const CloneIcon = () => (
  <svg
    name="CloneIcon"
    width="1em"
    height="1em"
    viewBox="0 0 27 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M24 19.7087C25.3895 18.6091 26 16.7624 26 14V8C26 3 24 1 19 1H13C10.8492 1 9.25357 1.37006 8.1334 2.18978M1 11.9997V17.9997C1 22.9997 3 24.9997 8 24.9997H14C19 24.9997 21 22.9997 21 17.9997V11.9997C21 6.99971 19 4.99971 14 4.99971H8C3 4.99971 1 6.99971 1 11.9997Z"
      stroke="currentColor"
      stroke-width="2"
      strokeMiterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
export const KebabMenuIcon = () => (
  <svg
    name="KebabMenuIcon"
    width="1em"
    height="1em"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9 14C9.53043 14 10.0391 14.2107 10.4142 14.5858C10.7893 14.9609 11 15.4696 11 16C11 16.5304 10.7893 17.0391 10.4142 17.4142C10.0391 17.7893 9.53043 18 9 18C8.46957 18 7.96086 17.7893 7.58579 17.4142C7.21071 17.0391 7 16.5304 7 16C7 15.4696 7.21071 14.9609 7.58579 14.5858C7.96086 14.2107 8.46957 14 9 14ZM9 7C9.53043 7 10.0391 7.21071 10.4142 7.58579C10.7893 7.96086 11 8.46957 11 9C11 9.53043 10.7893 10.0391 10.4142 10.4142C10.0391 10.7893 9.53043 11 9 11C8.46957 11 7.96086 10.7893 7.58579 10.4142C7.21071 10.0391 7 9.53043 7 9C7 8.46957 7.21071 7.96086 7.58579 7.58579C7.96086 7.21071 8.46957 7 9 7ZM9 0C9.53043 0 10.0391 0.210714 10.4142 0.585786C10.7893 0.960859 11 1.46957 11 2C11 2.53043 10.7893 3.03914 10.4142 3.41421C10.0391 3.78929 9.53043 4 9 4C8.46957 4 7.96086 3.78929 7.58579 3.41421C7.21071 3.03914 7 2.53043 7 2C7 1.46957 7.21071 0.960859 7.58579 0.585786C7.96086 0.210714 8.46957 0 9 0Z"
      fill="currentColor"
    />
  </svg>
);
export const ImageIcon = () => (
  <svg
    name="ImageIcon"
    width="1em"
    height="1em"
    viewBox="0 0 31 31"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.75 0H25.3333C26.5931 0 27.8013 0.500445 28.6921 1.39124C29.5829 2.28204 30.0833 3.49022 30.0833 4.75V25.3333C30.0833 26.5931 29.5829 27.8013 28.6921 28.6921C27.8013 29.5829 26.5931 30.0833 25.3333 30.0833H4.75C3.49022 30.0833 2.28204 29.5829 1.39124 28.6921C0.500445 27.8013 0 26.5931 0 25.3333V4.75C0 3.49022 0.500445 2.28204 1.39124 1.39124C2.28204 0.500445 3.49022 0 4.75 0ZM4.75 1.58333C3.91015 1.58333 3.10469 1.91696 2.51083 2.51083C1.91696 3.10469 1.58333 3.91015 1.58333 4.75V23.1008L8.37583 16.2925L12.3342 20.2508L20.2508 12.3342L28.5 20.5833V4.75C28.5 3.91015 28.1664 3.10469 27.5725 2.51083C26.9786 1.91696 26.1732 1.58333 25.3333 1.58333H4.75ZM12.3342 22.4992L8.37583 18.5408L1.58333 25.3333C1.58333 26.1732 1.91696 26.9786 2.51083 27.5725C3.10469 28.1664 3.91015 28.5 4.75 28.5H25.3333C26.1732 28.5 26.9786 28.1664 27.5725 27.5725C28.1664 26.9786 28.5 26.1732 28.5 25.3333V22.8158L20.2508 14.5825L12.3342 22.4992ZM8.70833 4.75C9.75815 4.75 10.765 5.16704 11.5073 5.90937C12.2496 6.6517 12.6667 7.65852 12.6667 8.70833C12.6667 9.75815 12.2496 10.765 11.5073 11.5073C10.765 12.2496 9.75815 12.6667 8.70833 12.6667C7.65852 12.6667 6.6517 12.2496 5.90937 11.5073C5.16704 10.765 4.75 9.75815 4.75 8.70833C4.75 7.65852 5.16704 6.6517 5.90937 5.90937C6.6517 5.16704 7.65852 4.75 8.70833 4.75ZM8.70833 6.33333C8.07844 6.33333 7.47435 6.58356 7.02895 7.02895C6.58356 7.47435 6.33333 8.07844 6.33333 8.70833C6.33333 9.33822 6.58356 9.94231 7.02895 10.3877C7.47435 10.8331 8.07844 11.0833 8.70833 11.0833C9.33822 11.0833 9.94231 10.8331 10.3877 10.3877C10.8331 9.94231 11.0833 9.33822 11.0833 8.70833C11.0833 8.07844 10.8331 7.47435 10.3877 7.02895C9.94231 6.58356 9.33822 6.33333 8.70833 6.33333Z"
      fill="#666666"
    />
  </svg>
);
export const PhoneIcon = () => (
  <svg
    name="PhoneIcon"
    width="1em"
    height="1em"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.6468 12.2202C14.6468 12.4602 14.5935 12.7068 14.4802 12.9468C14.3668 13.1868 14.2202 13.4135 14.0268 13.6268C13.7002 13.9868 13.3402 14.2468 12.9335 14.4135C12.5335 14.5802 12.1002 14.6668 11.6335 14.6668C10.9535 14.6668 10.2268 14.5068 9.46016 14.1802C8.6935 13.8535 7.92683 13.4135 7.16683 12.8602C6.40016 12.3002 5.6735 11.6802 4.98016 10.9935C4.2935 10.3002 3.6735 9.5735 3.12016 8.8135C2.5735 8.0535 2.1335 7.2935 1.8135 6.54016C1.4935 5.78016 1.3335 5.0535 1.3335 4.36016C1.3335 3.90683 1.4135 3.4735 1.5735 3.0735C1.7335 2.66683 1.98683 2.2935 2.34016 1.96016C2.76683 1.54016 3.2335 1.3335 3.72683 1.3335C3.9135 1.3335 4.10016 1.3735 4.26683 1.4535C4.44016 1.5335 4.5935 1.6535 4.7135 1.82683L6.26016 4.00683C6.38016 4.1735 6.46683 4.32683 6.52683 4.4735C6.58683 4.6135 6.62016 4.7535 6.62016 4.88016C6.62016 5.04016 6.5735 5.20016 6.48016 5.3535C6.3935 5.50683 6.26683 5.66683 6.10683 5.82683L5.60016 6.3535C5.52683 6.42683 5.4935 6.5135 5.4935 6.62016C5.4935 6.6735 5.50016 6.72016 5.5135 6.7735C5.5335 6.82683 5.5535 6.86683 5.56683 6.90683C5.68683 7.12683 5.8935 7.4135 6.18683 7.76016C6.48683 8.10683 6.80683 8.46016 7.1535 8.8135C7.5135 9.16683 7.86016 9.4935 8.2135 9.7935C8.56016 10.0868 8.84683 10.2868 9.0735 10.4068C9.10683 10.4202 9.14683 10.4402 9.1935 10.4602C9.24683 10.4802 9.30016 10.4868 9.36016 10.4868C9.4735 10.4868 9.56016 10.4468 9.6335 10.3735L10.1402 9.8735C10.3068 9.70683 10.4668 9.58016 10.6202 9.50016C10.7735 9.40683 10.9268 9.36016 11.0935 9.36016C11.2202 9.36016 11.3535 9.38683 11.5002 9.44683C11.6468 9.50683 11.8002 9.5935 11.9668 9.70683L14.1735 11.2735C14.3468 11.3935 14.4668 11.5335 14.5402 11.7002C14.6068 11.8668 14.6468 12.0335 14.6468 12.2202Z"
      stroke="currentColor"
      strokeMiterlimit="10"
    />
  </svg>
);
export const StarIcon = () => (
  <svg
    name="StarIcon"
    width="1em"
    height="1em"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.15327 2.33977L10.3266 4.68643C10.4866 5.0131 10.9133 5.32643 11.2733 5.38643L13.3999 5.73977C14.7599 5.96643 15.0799 6.9531 14.0999 7.92643L12.4466 9.57977C12.1666 9.85977 12.0133 10.3998 12.0999 10.7864L12.5733 12.8331C12.9466 14.4531 12.0866 15.0798 10.6533 14.2331L8.65994 13.0531C8.29994 12.8398 7.70661 12.8398 7.33994 13.0531L5.34661 14.2331C3.91994 15.0798 3.05327 14.4464 3.42661 12.8331L3.89994 10.7864C3.98661 10.3998 3.83327 9.85977 3.55327 9.57977L1.89994 7.92643C0.926606 6.9531 1.23994 5.96643 2.59994 5.73977L4.72661 5.38643C5.07994 5.32643 5.50661 5.0131 5.66661 4.68643L6.83994 2.33977C7.47994 1.06643 8.51994 1.06643 9.15327 2.33977Z"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
export const UsersIcon = () => (
  <svg
    name="UsersIcon"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.10671 7.24683C6.04004 7.24016 5.96004 7.24016 5.88671 7.24683C4.30004 7.1935 3.04004 5.8935 3.04004 4.2935C3.04004 2.66016 4.36004 1.3335 6.00004 1.3335C7.63337 1.3335 8.96004 2.66016 8.96004 4.2935C8.95337 5.8935 7.69337 7.1935 6.10671 7.24683Z"
      stroke="#292D32"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M10.9399 2.6665C12.2333 2.6665 13.2733 3.71317 13.2733 4.99984C13.2733 6.25984 12.2733 7.2865 11.0266 7.33317C10.9733 7.3265 10.9133 7.3265 10.8533 7.33317"
      stroke="#292D32"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M2.77323 9.7065C1.1599 10.7865 1.1599 12.5465 2.77323 13.6198C4.60657 14.8465 7.61323 14.8465 9.44657 13.6198C11.0599 12.5398 11.0599 10.7798 9.44657 9.7065C7.6199 8.4865 4.61323 8.4865 2.77323 9.7065Z"
      stroke="#292D32"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M12.2266 13.3335C12.7066 13.2335 13.1599 13.0402 13.5332 12.7535C14.5732 11.9735 14.5732 10.6868 13.5332 9.90683C13.1666 9.62683 12.7199 9.44016 12.2466 9.3335"
      stroke="#292D32"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
export const AddFolderIcon = () => (
  <svg
    name="AddFolderIcon"
    width="1em"
    height="1em"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.04004 10.9998V7.6665"
      stroke="currentColor"
      strokeMiterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M9.66671 9.3335H6.33337"
      stroke="currentColor"
      strokeMiterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M14.6667 7.3335V11.3335C14.6667 14.0002 14 14.6668 11.3334 14.6668H4.66671C2.00004 14.6668 1.33337 14.0002 1.33337 11.3335V4.66683C1.33337 2.00016 2.00004 1.3335 4.66671 1.3335H5.66671C6.66671 1.3335 6.88671 1.62683 7.26671 2.1335L8.26671 3.46683C8.52004 3.80016 8.66671 4.00016 9.33337 4.00016H11.3334C14 4.00016 14.6667 4.66683 14.6667 7.3335Z"
      stroke="currentColor"
      strokeMiterlimit="10"
    />
  </svg>
);
export const InvoiceIcon = () => (
  <svg
    name="InvoiceIcon"
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21 7V17C21 20 19.5 22 16 22H8C4.5 22 3 20 3 17V7C3 4 4.5 2 8 2H16C19.5 2 21 4 21 7Z"
      stroke="currentColor"
      strokeMiterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M14.5 4.5V6.5C14.5 7.6 15.4 8.5 16.5 8.5H18.5"
      stroke="currentColor"
      strokeMiterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M8 13H12"
      stroke="currentColor"
      strokeMiterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M8 17H16"
      stroke="currentColor"
      strokeMiterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
export const ShareIcon = () => (
  <svg
    name="ShareIcon"
    width="1em"
    height="1em"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="1"
    stroke-linecap="round"
    stroke-linejoin="round"
  >
    <circle cx="18" cy="5" r="3" />
    <circle cx="6" cy="12" r="3" />
    <circle cx="18" cy="19" r="3" />
    <line x1="8.59" x2="15.42" y1="13.51" y2="17.49" />
    <line x1="15.41" x2="8.59" y1="6.51" y2="10.49" />
  </svg>
);
export const FilterIcon = () => (
  <svg
    name="FilterIcon"
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.3201 19.0698C14.3201 19.6798 13.92 20.4798 13.41 20.7898L12.0001 21.6998C10.6901 22.5098 8.87006 21.5998 8.87006 19.9798V14.6298C8.87006 13.9198 8.47006 13.0098 8.06006 12.5098L4.22003 8.46976C3.71003 7.95976 3.31006 7.05977 3.31006 6.44977V4.12976C3.31006 2.91976 4.22008 2.00977 5.33008 2.00977H18.67C19.78 2.00977 20.6901 2.91975 20.6901 4.02975V6.24976C20.6901 7.05976 20.1801 8.06976 19.6801 8.56976"
      stroke="currentColor"
      stroke-width="1.5"
      strokeMiterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M16.0701 16.5201C17.8374 16.5201 19.2701 15.0874 19.2701 13.3201C19.2701 11.5528 17.8374 10.1201 16.0701 10.1201C14.3028 10.1201 12.8701 11.5528 12.8701 13.3201C12.8701 15.0874 14.3028 16.5201 16.0701 16.5201Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M19.8701 17.1201L18.8701 16.1201"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
export const DownloadIcon = () => (
  <svg
    name="DownloadIcon"
    width="1em"
    height="1em"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="1"
    stroke-linecap="round"
    stroke-linejoin="round"
    class="lucide lucide-download-icon lucide-download"
  >
    <path d="M12 15V3" />
    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
    <path d="m7 10 5 5 5-5" />
  </svg>
);
export const ArrowTopRightCornerIcon = () => (
  <svg
    name="ArrowTopRightCornerIcon"
    width="1em"
    height="1em"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M24.9479 1.38595V19.4033C24.9479 19.7709 24.8019 20.1234 24.5419 20.3833C24.282 20.6432 23.9295 20.7892 23.5619 20.7892C23.1943 20.7892 22.8418 20.6432 22.5819 20.3833C22.322 20.1234 22.176 19.7709 22.176 19.4033V4.73129L2.36728 24.5417C2.10722 24.8018 1.7545 24.9479 1.38672 24.9479C1.01894 24.9479 0.666222 24.8018 0.406161 24.5417C0.1461 24.2816 0 23.9289 0 23.5611C0 23.1934 0.1461 22.8407 0.406161 22.5806L20.2166 2.7719H5.54457C5.17699 2.7719 4.82447 2.62588 4.56456 2.36596C4.30464 2.10605 4.15862 1.75353 4.15862 1.38595C4.15862 1.01837 4.30464 0.665852 4.56456 0.405936C4.82447 0.14602 5.17699 0 5.54457 0L23.5619 0C23.9295 0 24.282 0.14602 24.5419 0.405936C24.8019 0.665852 24.9479 1.01837 24.9479 1.38595Z"
      fill="currentColor"
    />
  </svg>
);
export const MusicIcon = (props) => (
  <svg width={props.width} height={props.height} viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M39.9995 58.2335C39.9995 61.7962 38.5842 65.2131 36.0649 67.7323C33.5457 70.2515 30.1289 71.6668 26.5661 71.6668C23.0034 71.6668 19.5866 70.2515 17.0673 67.7323C14.5481 65.2131 13.1328 61.7962 13.1328 58.2335C13.1328 54.6708 14.5481 51.2539 17.0673 48.7347C19.5866 46.2155 23.0034 44.8002 26.5661 44.8002C30.1289 44.8002 33.5457 46.2155 36.0649 48.7347C38.5842 51.2539 39.9995 54.6708 39.9995 58.2335ZM39.9995 58.2335V8.3335L61.2995 14.4002C62.9017 14.8565 64.3118 15.8223 65.3162 17.1515C66.3206 18.4807 66.8647 20.1008 66.8661 21.7668V24.9935C66.8621 26.1626 66.591 27.3153 66.0736 28.3637C65.5563 29.4122 64.8063 30.3285 63.8809 31.043C62.9555 31.7575 61.8791 32.2511 60.7339 32.4863C59.5887 32.7215 58.4049 32.6921 57.2728 32.4002L39.9995 27.5268" stroke="white" stroke-width="3.75" stroke-linecap="round"/>
  </svg>
)
export const BusinessIcon = (props) => (
  <svg width={props.width} height={props.height} viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M79.4681 33.7219L71.4931 17.7657C71.1993 17.1784 70.7927 16.6547 70.2965 16.2246C69.8003 15.7944 69.2243 15.4663 68.6012 15.2588C67.9782 15.0513 67.3204 14.9686 66.6654 15.0153C66.0104 15.0621 65.371 15.2374 64.7837 15.5313L57.0119 19.4157L40.64 15.0844C40.2199 14.9751 39.7788 14.9751 39.3587 15.0844L22.9869 19.4157L15.215 15.5313C14.6278 15.2374 13.9884 15.0621 13.3334 15.0153C12.6783 14.9686 12.0205 15.0513 11.3975 15.2588C10.7745 15.4663 10.1984 15.7944 9.70221 16.2246C9.20602 16.6547 8.79942 17.1784 8.50562 17.7657L0.530625 33.7188C0.236738 34.3061 0.0614071 34.9454 0.0146462 35.6004C-0.0321148 36.2555 0.0506096 36.9133 0.258095 37.5363C0.465581 38.1593 0.793764 38.7354 1.2239 39.2316C1.65404 39.7278 2.17771 40.1344 2.765 40.4282L11.2025 44.6501L28.5431 57.0344C28.7988 57.216 29.086 57.3484 29.39 57.4251L49.39 62.4251C49.8088 62.5301 50.2477 62.5249 50.664 62.4098C51.0802 62.2948 51.4595 62.074 51.765 61.7688L68.9744 44.5563L77.2306 40.4282C78.4159 39.8348 79.3171 38.7951 79.7361 37.5376C80.155 36.2801 80.0575 34.9076 79.465 33.7219H79.4681ZM62.315 44.1501L51.5619 35.5376C51.0801 35.1518 50.4727 34.9578 49.8566 34.993C49.2404 35.0282 48.659 35.2901 48.2244 35.7282C42.6588 41.3344 36.4556 40.6251 32.4994 38.1251L46.0119 25.0001H55.9525L64.4556 42.0032L62.315 44.1501ZM12.9775 20.0001L19.3744 23.1938L11.3837 39.1469L4.99937 35.9563L12.9775 20.0001ZM49.2275 57.2282L31.0681 52.6907L15.6931 41.7094L24.4431 24.2094L39.9994 20.0876L43.0619 20.8969L28.9994 34.5469L28.9744 34.5751C28.445 35.1044 28.0413 35.7459 27.793 36.4521C27.5447 37.1584 27.4581 37.9113 27.5397 38.6555C27.6213 39.3997 27.8689 40.116 28.2643 40.7517C28.6598 41.3873 29.1929 41.9261 29.8244 42.3282C36.2494 46.4313 44.0025 45.7657 50.1088 40.7657L58.7494 47.7063L49.2275 57.2282ZM68.6025 39.1438L60.6275 23.2063L67.0212 20.0001L74.9994 35.9563L68.6025 39.1438ZM41.1806 68.1032C41.0456 68.6435 40.7339 69.1233 40.2952 69.4663C39.8564 69.8094 39.3157 69.9962 38.7588 69.9969C38.5533 69.9971 38.3486 69.9719 38.1494 69.9219L25.1275 66.6657C24.823 66.5905 24.5355 66.4579 24.2806 66.2751L16.0462 60.3938C15.5399 59.9963 15.2065 59.4188 15.1153 58.7815C15.0242 58.1443 15.1823 57.4965 15.5569 56.9729C15.9314 56.4494 16.4934 56.0905 17.126 55.9709C17.7585 55.8514 18.4128 55.9805 18.9525 56.3313L26.7994 61.9376L39.3744 65.0751C40.0175 65.2359 40.5703 65.6456 40.9114 66.2141C41.2525 66.7825 41.3538 67.4632 41.1931 68.1063L41.1806 68.1032Z" fill="white"/>
  </svg>
)
export const FoodDrinkIcon = (props) => (
  <svg width={props.width} height={props.height} viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M32.6027 10.0465C32.7042 11.283 33.2389 12.444 34.1127 13.3249C35.1091 14.3218 35.6688 15.6737 35.6688 17.0832C35.6688 18.4927 35.1091 19.8445 34.1127 20.8415C33.1158 21.8386 32.5558 23.1908 32.5558 24.6007C32.5558 26.0106 33.1158 27.3628 34.1127 28.3599C35.1091 29.3568 35.6688 30.7087 35.6688 32.1182C35.6688 33.5277 35.1091 34.8795 34.1127 35.8765M38.4793 9.18652C38.3727 10.6715 38.8627 12.1899 39.9994 13.3249C40.9957 14.3218 41.5554 15.6737 41.5554 17.0832C41.5554 18.4927 40.9957 19.8445 39.9994 20.8415C39.0025 21.8386 38.4424 23.1908 38.4424 24.6007C38.4424 26.0106 39.0025 27.3628 39.9994 28.3599C40.9957 29.3568 41.5554 30.7087 41.5554 32.1182C41.5554 33.5277 40.9957 34.8795 39.9994 35.8765M44.2644 9.44986C44.2454 10.1668 44.3726 10.8801 44.6382 11.5463C44.9038 12.2125 45.3023 12.8176 45.8094 13.3249C46.8057 14.3218 47.3654 15.6737 47.3654 17.0832C47.3654 18.4927 46.8057 19.8445 45.8094 20.8415C44.8125 21.8386 44.2524 23.1908 44.2524 24.6007C44.2524 26.0106 44.8125 27.3628 45.8094 28.3599C46.8057 29.3568 47.3654 30.7087 47.3654 32.1182C47.3654 33.5277 46.8057 34.8795 45.8094 35.8765M9.16602 28.4332L20.0327 39.9799M9.16602 39.9815C9.16602 57.0099 22.971 70.8149 39.9994 70.8149C57.0277 70.8149 70.8327 57.0099 70.8327 39.9815H9.16602Z" stroke="white" stroke-width="3.75" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
)
export const CommunityIcon = (props) => (
  <svg width={props.width} height={props.height} viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M69.9993 70H9.99935C9.11529 70 8.26745 69.6488 7.64233 69.0237C7.0172 68.3986 6.66602 67.5507 6.66602 66.6667V41.6233C6.66596 41.147 6.76799 40.6763 6.96521 40.2427C7.16243 39.8092 7.45027 39.4229 7.80935 39.11L19.9993 28.48V13.3333C19.9993 12.4493 20.3505 11.6014 20.9757 10.9763C21.6008 10.3512 22.4486 10 23.3327 10H69.9993C70.8834 10 71.7312 10.3512 72.3564 10.9763C72.9815 11.6014 73.3327 12.4493 73.3327 13.3333V66.6667C73.3327 67.5507 72.9815 68.3986 72.3564 69.0237C71.7312 69.6488 70.8834 70 69.9993 70ZM29.9993 63.3333H39.9993V43.14L26.666 31.5133L13.3327 43.14V63.3333H23.3327V50H29.9993V63.3333ZM46.666 63.3333H66.666V16.6667H26.666V23.7567C27.446 23.7567 28.2293 24.03 28.856 24.58L45.5227 39.11C45.8818 39.4229 46.1696 39.8092 46.3668 40.2427C46.564 40.6763 46.6661 41.147 46.666 41.6233V63.3333ZM53.3327 36.6667H59.9993V43.3333H53.3327V36.6667ZM53.3327 50H59.9993V56.6667H53.3327V50ZM53.3327 23.3333H59.9993V30H53.3327V23.3333ZM39.9993 23.3333H46.666V30H39.9993V23.3333Z" fill="white"/>
  </svg>
)
export const ArtsIcon = (props) => (
  <svg width={props.width} height={props.height} viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M40.4807 70.7835C23.1841 70.6868 9.16406 57.0001 9.16406 40.0001C9.16406 23.0001 23.1841 9.2168 40.4807 9.2168C51.4841 9.2168 61.0274 15.2835 66.7474 23.2335C69.4641 27.0085 71.9691 32.3418 70.2991 40.3635C68.6324 48.3851 60.3924 53.5101 55.7607 53.5101H48.2507C41.7574 53.5101 41.1424 59.6218 43.8591 62.5035C46.4091 65.2085 44.5441 70.8068 40.4807 70.7835Z" stroke="white" stroke-width="3.75" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M26.1426 40.0709C26.1428 40.7736 26.4113 39.4216 26.1426 40.0709ZM26.1426 40.0709C25.8738 40.7202 25.4798 41.3102 24.9829 41.8071C24.4861 42.3041 23.8963 42.6983 23.2471 42.9673C22.5979 43.2363 21.902 43.3747 21.1993 43.3747C19.78 43.3747 18.4188 42.8109 17.4151 41.8072C16.4115 40.8036 15.8477 39.4424 15.8477 38.023C15.8477 36.6037 16.4115 35.2425 17.4151 34.2388C18.4188 33.2352 19.78 32.6714 21.1993 32.6714C21.902 32.6714 22.5979 32.8098 23.2471 33.0788C23.8963 33.3477 24.4861 33.742 24.9829 34.2389C25.4798 34.7359 25.8738 35.3259 26.1426 35.9752C26.4113 36.6244 26.1428 39.3682 26.1426 40.0709ZM64.1443 38.023C64.1445 38.7259 64.0063 39.4219 63.7374 40.0713C63.4685 40.7207 63.0743 41.3107 62.5774 41.8077C62.0804 42.3047 61.4903 42.6989 60.8409 42.9678C60.1915 43.2366 59.4955 43.3749 58.7927 43.3747C58.09 43.3749 57.3941 43.2367 56.7448 42.9679C56.0955 42.6992 55.5055 42.3051 55.0086 41.8083C54.5116 41.3115 54.1174 40.7216 53.8484 40.0724C53.5794 39.4232 53.441 38.7274 53.441 38.0247C53.4406 37.3218 53.5786 36.6258 53.8473 35.9763C54.1159 35.3268 54.51 34.7367 55.0068 34.2395C55.5036 33.7424 56.0936 33.348 56.7429 33.0789C57.3922 32.8099 58.0881 32.6714 58.791 32.6714C59.494 32.6709 60.1902 32.809 60.8398 33.0778C61.4893 33.3466 62.0796 33.7407 62.5768 34.2378C63.0739 34.7348 63.4683 35.3249 63.7372 35.9744C64.0062 36.6239 64.1445 37.32 64.1443 38.023ZM54.0727 24.3314C54.0727 25.7507 53.5088 27.1119 52.5052 28.1156C51.5016 29.1192 50.1403 29.683 48.721 29.683C47.3016 29.683 45.9404 29.1192 44.9368 28.1156C43.9332 27.1119 43.3693 25.7507 43.3693 24.3314C43.3691 23.6285 43.5074 22.9325 43.7763 22.2831C44.0451 21.6337 44.4393 21.0437 44.9363 20.5467C45.4333 20.0497 46.0233 19.6555 46.6727 19.3866C47.3221 19.1178 48.0181 18.9795 48.721 18.9797C49.4237 18.9795 50.1196 19.1177 50.7689 19.3865C51.4181 19.6552 52.0081 20.0493 52.5051 20.5461C53.0021 21.0429 53.3963 21.6328 53.6653 22.282C53.9342 22.9312 54.0727 23.6286 54.0727 24.3314ZM36.621 24.3314C36.621 25.7503 36.0573 27.1111 35.054 28.1144C34.0507 29.1177 32.6899 29.6814 31.271 29.6814C30.2124 29.6817 29.1775 29.3681 28.2971 28.7801C27.4168 28.1922 26.7306 27.3564 26.3253 26.3785C25.9201 25.4005 25.814 24.3243 26.0204 23.286C26.2268 22.2478 26.7366 21.294 27.4851 20.5455C28.2337 19.797 29.1874 19.2872 30.2257 19.0808C31.264 18.8743 32.3401 18.9805 33.3181 19.3857C34.296 19.791 35.1318 20.4772 35.7198 21.3575C36.3077 22.2378 36.6213 23.2728 36.621 24.3314Z" stroke="white" stroke-width="3.75" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
)
export const HealthIcon = (props) => (
  <svg width={props.width} height={props.height} viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M67.3104 43.33C68.6443 45.6054 69.515 48.1222 69.8723 50.7355C70.2296 53.3488 70.0665 56.0069 69.3923 58.5569C68.7182 61.1069 67.5463 63.4983 65.9441 65.5936C64.3419 67.6888 62.3411 69.4464 60.0569 70.7653C57.7727 72.0841 55.2502 72.9381 52.6346 73.278C50.019 73.618 47.362 73.4373 44.8165 72.7462C42.2711 72.0551 39.8874 70.8674 37.8029 69.2513C35.7183 67.6353 33.974 65.6229 32.6704 63.33M67.3104 43.33C64.6393 38.7739 60.2746 35.4592 55.1687 34.1092C50.0628 32.7593 44.6302 33.4838 40.0565 36.1245C35.4827 38.7652 32.1391 43.1079 30.7554 48.2047C29.3716 53.3015 30.06 58.7388 32.6704 63.33M67.3104 43.33L32.6704 63.33" stroke="white" stroke-width="3.28166"/>
    <path d="M33.4767 18.4732L50.4267 8.45653C56.6667 4.76987 64.6467 6.95653 68.25 13.3465C69.627 15.7915 70.214 18.6025 69.9305 21.3942C69.6471 24.1859 68.507 26.8216 66.6667 28.9399M33.4767 18.4732L16.5267 28.4899C10.2867 32.1765 8.14669 40.3432 11.75 46.7299C12.7569 48.5413 14.1823 50.0858 15.9074 51.2344C17.6324 52.3831 19.6071 53.1027 21.6667 53.3332M33.4767 18.4732L38.3334 26.6665" stroke="white" stroke-width="3.28166" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
)
export const ScienceTechIcon = (props) => (
  <svg width={props.width} height={props.height} viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M34.4121 24.8398C30.5177 27.7925 26.8326 31.0116 23.3836 34.4741C7.13213 50.7256 -1.09644 68.8341 4.99499 74.9313C11.0864 81.0227 29.2007 72.7884 45.4464 56.5427C48.9091 53.0918 52.1283 49.4048 55.0807 45.5084" stroke="white" stroke-width="3.75047" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M55.081 45.5085C64.6638 58.2285 68.5667 70.1942 63.8353 74.9256C57.7381 81.0228 39.6295 72.7885 23.3781 56.5428C7.13812 40.2856 -1.09045 22.1828 5.00097 16.0856C9.7324 11.3599 21.6981 15.2628 34.4181 24.8399" stroke="white" stroke-width="3.75047" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M45.8975 20.6285C44.0975 20.3142 44.0975 17.7371 45.8975 17.4285C49.0775 16.8777 52.0211 15.3912 54.352 13.159C56.6829 10.9268 58.2954 8.05031 58.9833 4.89711L59.0861 4.39996C59.4747 2.62853 62.0004 2.61711 62.4004 4.38282L62.5375 4.95996C63.2548 8.09755 64.8825 10.9535 67.2166 13.1696C69.5506 15.3857 72.487 16.8633 75.6575 17.4171C77.4633 17.7314 77.4633 20.3257 75.6575 20.6342C72.487 21.188 69.5506 22.6656 67.2166 24.8817C64.8825 27.0978 63.2548 29.9538 62.5375 33.0914L62.4004 33.6685C62.0004 35.44 59.4747 35.4285 59.0861 33.6571L58.9718 33.16C58.2839 30.0068 56.6715 27.1303 54.3406 24.8981C52.0097 22.6659 49.0661 21.1794 45.8861 20.6285M31.5547 45.5085C31.5547 46.2663 31.8557 46.993 32.3915 47.5288C32.9273 48.0647 33.6541 48.3657 34.4118 48.3657C35.1696 48.3657 35.8963 48.0647 36.4321 47.5288C36.968 46.993 37.269 46.2663 37.269 45.5085C37.269 44.7508 36.968 44.024 36.4321 43.4882C35.8963 42.9524 35.1696 42.6514 34.4118 42.6514C33.6541 42.6514 32.9273 42.9524 32.3915 43.4882C31.8557 44.024 31.5547 44.7508 31.5547 45.5085Z" stroke="white" stroke-width="3.75047" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
)
export const SportsIcon = (props) => (
  <svg width={props.width} height={props.height} viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M11.416 66.6667L6.66602 62.0001L20.3327 48.3334C22.0549 46.6112 23.236 44.459 23.876 41.8767C24.516 39.2945 24.8349 35.3356 24.8327 30.0001C24.8327 26.7778 25.5549 23.6112 26.9993 20.5001C28.4438 17.389 30.4993 14.5001 33.166 11.8334C38.2216 6.77784 43.8049 3.91673 49.916 3.25006C56.0271 2.5834 61.0549 4.27784 64.9993 8.3334C68.9993 12.3334 70.666 17.389 69.9993 23.5001C69.3327 29.6112 66.4994 35.1667 61.4994 40.1667C58.8327 42.8334 55.9438 44.889 52.8327 46.3334C49.7216 47.7778 46.5549 48.5001 43.3327 48.5001C37.9438 48.5001 33.9993 48.8056 31.4993 49.4167C28.9993 50.0278 26.8605 51.2223 25.0827 53.0001L11.416 66.6667ZM34.3327 38.8334C36.9438 41.389 40.4716 42.3334 44.916 41.6667C49.3605 41.0001 53.3327 38.9167 56.8327 35.4167C60.3882 31.8612 62.5138 27.8745 63.2093 23.4567C63.9049 19.039 62.946 15.5812 60.3327 13.0834C57.666 10.4167 54.1805 9.41673 49.876 10.0834C45.5716 10.7501 41.6127 12.8612 37.9993 16.4167C34.4993 19.9167 32.3749 23.8756 31.626 28.2934C30.8771 32.7112 31.7793 36.2245 34.3327 38.8334ZM50.5827 72.7501C47.9716 70.139 46.666 67.0001 46.666 63.3334C46.666 59.6667 47.9716 56.5278 50.5827 53.9167C53.1938 51.3056 56.3327 50.0001 59.9993 50.0001C63.666 50.0001 66.8049 51.3056 69.416 53.9167C72.0271 56.5278 73.3327 59.6667 73.3327 63.3334C73.3327 67.0001 72.0271 70.139 69.416 72.7501C66.8049 75.3612 63.666 76.6667 59.9993 76.6667C56.3327 76.6667 53.1938 75.3612 50.5827 72.7501ZM64.7093 68.0434C66.0138 66.7367 66.666 65.1667 66.666 63.3334C66.666 61.5001 66.0138 59.9312 64.7093 58.6267C63.4049 57.3223 61.8349 56.669 59.9993 56.6667C58.1638 56.6645 56.5949 57.3178 55.2927 58.6267C53.9905 59.9356 53.3371 61.5045 53.3327 63.3334C53.3282 65.1623 53.9816 66.7323 55.2927 68.0434C56.6038 69.3545 58.1727 70.0067 59.9993 70.0001C61.826 69.9934 63.396 69.3412 64.7093 68.0434Z" fill="white"/>
  </svg>
)
export const TravelOutdoorIcon = (props) => (
  <svg width={props.width} height={props.height} viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M47.1133 23.3067L58.4333 11.9834C59.7077 10.7297 61.4259 10.0303 63.2135 10.0377C65.0012 10.045 66.7136 10.7584 67.9776 12.0224C69.2417 13.2865 69.9551 14.9989 69.9624 16.7866C69.9697 18.5742 69.2704 20.2924 68.0167 21.5667L56.6933 32.8867L62.82 63.3701C63.6033 67.2701 56.04 72.7034 54.0267 67.5367L45.06 44.5234L33.4167 56.1667C33.9833 62.9701 34.1067 65.2334 29.3367 70.0001L22.0867 57.9134L10 50.6634C14.7667 45.8934 17.03 46.0134 23.8333 46.5834L35.4767 34.9434L12.4633 25.9734C7.29667 23.9601 12.73 16.3934 16.63 17.1801L47.1133 23.3067Z" stroke="white" stroke-width="3.75" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
)
export const FilmMediaIcon = (props) => (
  <svg width={props.width} height={props.height} viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M5.45333 66.9265C5.77333 71.1632 9.09167 74.3032 13.3333 74.5465C17.4583 74.7815 23.4867 74.9998 31.6667 74.9998C39.8467 74.9998 45.875 74.7815 50 74.5465C54.2417 74.3032 57.56 71.1632 57.88 66.9265C58.1267 63.6498 58.3333 59.1665 58.3333 53.3332C58.3333 47.4998 58.1267 43.0165 57.88 39.7398C57.56 35.5032 54.2417 32.3632 50 32.1198C45.875 31.8848 39.845 31.6665 31.6667 31.6665C23.4883 31.6665 17.4583 31.8848 13.3333 32.1215C9.09167 32.3632 5.77333 35.5032 5.45333 39.7382C5.20667 43.0165 5 47.5032 5 53.3332C5 59.1632 5.20667 63.6498 5.45333 66.9265Z" stroke="white" stroke-width="3.75" stroke-linejoin="round"/>
    <path d="M58.1577 62.15C58.2644 59.645 58.3327 56.7167 58.3327 53.3333C58.3327 49.95 58.2644 47.02 58.156 44.515C60.881 43.0633 64.7227 41.17 68.5443 39.8067C71.546 38.735 74.3977 40.5633 74.6644 43.74C74.8527 45.995 74.9994 49.1067 74.9994 53.3317C74.9994 57.5583 74.8527 60.6683 74.6644 62.9233C74.3977 66.1 71.5477 67.9283 68.5443 66.8567C64.7243 65.495 60.881 63.6033 58.1577 62.15ZM11.666 14.1667C11.666 16.5978 12.6318 18.9294 14.3509 20.6485C16.07 22.3676 18.4015 23.3333 20.8327 23.3333C23.2638 23.3333 25.5954 22.3676 27.3145 20.6485C29.0336 18.9294 29.9993 16.5978 29.9993 14.1667C29.9993 11.7355 29.0336 9.40394 27.3145 7.68485C25.5954 5.96577 23.2638 5 20.8327 5C18.4015 5 16.07 5.96577 14.3509 7.68485C12.6318 9.40394 11.666 11.7355 11.666 14.1667ZM38.3327 16.6667C38.3327 18.4348 39.0351 20.1305 40.2853 21.3807C41.5355 22.631 43.2312 23.3333 44.9994 23.3333C46.7675 23.3333 48.4632 22.631 49.7134 21.3807C50.9636 20.1305 51.666 18.4348 51.666 16.6667C51.666 14.8986 50.9636 13.2029 49.7134 11.9526C48.4632 10.7024 46.7675 10 44.9994 10C43.2312 10 41.5355 10.7024 40.2853 11.9526C39.0351 13.2029 38.3327 14.8986 38.3327 16.6667ZM38.371 44.4183C38.426 42.98 39.3577 41.885 40.791 41.7617C41.6365 41.6941 42.4845 41.6624 43.3327 41.6667C44.3827 41.6667 45.216 41.7067 45.8743 41.7617C47.3077 41.885 48.241 42.9817 48.2943 44.4183C48.3177 45.0133 48.3327 45.7517 48.3327 46.6667C48.3327 47.5817 48.316 48.32 48.2943 48.915C48.2393 50.3533 47.3077 51.4483 45.8743 51.5717C45.0289 51.6393 44.1809 51.6709 43.3327 51.6667C42.2827 51.6667 41.4494 51.6283 40.791 51.5717C39.3577 51.4483 38.4244 50.3533 38.371 48.915C38.3477 48.32 38.3327 47.5817 38.3327 46.6667C38.3327 45.7517 38.3494 45.0133 38.371 44.4183Z" stroke="white" stroke-width="3.75" stroke-linejoin="round"/>
  </svg>
)
export const EducationIcon = (props) => (
  <svg width={props.width} height={props.height} viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M13.334 63.3333V16.6667C13.334 14.8986 14.0364 13.2029 15.2866 11.9526C16.5368 10.7024 18.2325 10 20.0007 10H64.6673C65.1978 10 65.7065 10.2107 66.0815 10.5858C66.4566 10.9609 66.6673 11.4696 66.6673 12V55.7133M20.0007 56.6667H66.6673M20.0007 70H66.6673" stroke="white" stroke-width="3.75" stroke-linecap="round"/>
    <path d="M20.0007 69.9998C18.2325 69.9998 16.5368 69.2975 15.2866 68.0472C14.0364 66.797 13.334 65.1013 13.334 63.3332C13.334 61.5651 14.0364 59.8694 15.2866 58.6191C16.5368 57.3689 18.2325 56.6665 20.0007 56.6665" stroke="white" stroke-width="3.75" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M30 23.3335H50" stroke="white" stroke-width="3.75" stroke-linecap="round"/>
  </svg>
)
export const OnlineEventsIcon = (props) => (
  <svg width={props.width} height={props.height} viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M70.0007 6.6665H10.0007C8.23254 6.6665 6.53685 7.36888 5.28661 8.61913C4.03636 9.86937 3.33398 11.5651 3.33398 13.3332V53.3332C3.33398 55.1013 4.03636 56.797 5.28661 58.0472C6.53685 59.2975 8.23254 59.9998 10.0007 59.9998H38V66.6665H26.6673V73.3332H53.334V66.6665H42.5V59.9998H70.0007C71.7688 59.9998 73.4645 59.2975 74.7147 58.0472C75.9649 56.797 76.6673 55.1013 76.6673 53.3332V13.3332C76.6673 11.5651 75.9649 9.86937 74.7147 8.61913C73.4645 7.36888 71.7688 6.6665 70.0007 6.6665ZM72 56L7.5 56.5V33.5V10.5H39.5H72V56Z" fill="white"/>
    <path d="M20 23.3333V43.3333C20 44.2174 20.3512 45.0652 20.9763 45.6904C21.6014 46.3155 22.4493 46.6667 23.3333 46.6667H56.6667C57.5507 46.6667 58.3986 46.3155 59.0237 45.6904C59.6488 45.0652 60 44.2174 60 43.3333V23.3333C60 22.4493 59.6488 21.6014 59.0237 20.9763C58.3986 20.3512 57.5507 20 56.6667 20H23.3333C22.4493 20 21.6014 20.3512 20.9763 20.9763C20.3512 21.6014 20 22.4493 20 23.3333ZM56.6667 43.3333H23.3333V26.6667H56.6667V43.3333Z" fill="white"/>
  </svg>
)